/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Diet_LunchInputs */

const en_platform_diet_lunch = /** @type {(inputs: Platform_Diet_LunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunch`)
};

const pl_platform_diet_lunch = /** @type {(inputs: Platform_Diet_LunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiad`)
};

/**
* | output |
* | --- |
* | "Lunch" |
*
* @param {Platform_Diet_LunchInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_diet_lunch = /** @type {((inputs?: Platform_Diet_LunchInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Diet_LunchInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_diet_lunch(inputs)
	return en_platform_diet_lunch(inputs)
});